<template>
  <div class="subject" :class="{ 'fullscreen-mode': isFullscreen }">
    <!-- 缩放容器 -->
    <div class="scale-container" :style="scaleContainerStyle">
      <!-- 地图作为底层背景 -->
      <div class="map-modules">
        <big-user-map :show-layer-data="showLayerData" :layer-query-data="layerQueryData"></big-user-map>
      </div>

      <div class="map-operation-modules">
        <layer-query-map style="align-self: flex-end;" @layerQuery="layerQueryChild"></layer-query-map>
        <layer-operation-map style="margin-left: auto;" @showLayer="showLayerChild"></layer-operation-map>
      </div>
      <!-- 顶部导航栏 -->
      <div class="top-modules">
        <navigation-bar :is-fullscreen="isFullscreen"
          @toggle-custom-fullscreen="toggleCustomFullscreen"></navigation-bar>
      </div>

      <!-- 左侧模块 -->
      <div class="left-modules-bg"></div>
      <div class="left-modules">
        <left-user-analysis style="margin-top: 6px; "></left-user-analysis>
        <left-user-water-meter style="margin-top: 26px;"></left-user-water-meter>
      </div>

      <!-- 右侧模块 -->
      <div class="right-modules-bg"></div>
      <div class="right-modules">
        <right-ranking style="margin-top: 6px; "></right-ranking>
        <right-volatility style="margin-top: 40px;"></right-volatility>
      </div>

      <div class="bottom-modules">
        <bottom-alarm></bottom-alarm>
        <bottom-water-use></bottom-water-use>
      </div>
      <div class="bottom-modules-bg"></div>
    </div>
  </div>
</template>

<script>
import BigUserMap from './modules/BigUserMap.vue';
import NavigationBar from './modules/NavigationBar.vue';
import LeftUserWaterMeter from './modules/LeftUserWaterMeter.vue';
import LeftUserAnalysis from './modules/LeftUserAnalysis.vue';
import BottomAlarm from './modules/BottomAlarm.vue';
import RightRanking from './modules/RightRanking.vue';
import RightVolatility from './modules/RightVolatility.vue';
import BottomWaterUse from './modules/BottomWaterUse.vue';
import layerOperationMap from './modules/layerOperationMap.vue';
import layerQueryMap from './modules/layerQueryMap.vue';
export default {
  name: 'Home',
  components: {
    BigUserMap,
    NavigationBar,
    LeftUserWaterMeter,
    LeftUserAnalysis,
    BottomAlarm,
    RightRanking,
    RightVolatility,
    BottomWaterUse,
    layerOperationMap,
    layerQueryMap
  },
  computed: {
    // 缩放容器样式
    scaleContainerStyle () {
      if (this.isFullscreen) {
        return {
          transform: `translate(-50%, -50%) scale(${this.scaleValue})`,
          transformOrigin: 'center center'
        };
      } else {
        return {
          transform: `translateX(-50%) scale(${this.scaleValue})`,
          transformOrigin: 'top center'
        };
      }
    }
  },
  data () {
    return {
      workTableUrl: '/bigusers/workbench/userControl/AllUserPage',
      showLayerData: {},
      layerQueryData: {},
      isFullscreen: false,
      // 缩放相关数据
      scaleValue: 1,
      baseWidth: 1920, // 设计稿基准宽度
      baseHeight: 1080, // 设计稿基准高度
      resizeTimer: null
    };
  },
  mounted () {
    // 监听浏览器全屏状态变化
    this.addFullscreenListeners();
    // 初始化时检查一次全屏状态
    this.handleFullscreenChange();
    // 初始化缩放计算
    this.calculateScale();
    // 监听窗口大小变化
    this.addResizeListeners();
  },
  beforeDestroy () {
    // 移除全屏状态监听器
    this.removeFullscreenListeners();
    // 移除窗口大小变化监听器
    this.removeResizeListeners();
    // 清除定时器
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  methods: {
    jumpWorkTable () {
      this.$router.push({ path: this.workTableUrl });
    },
    //子组件图层隐藏按钮
    showLayerChild (item) {
      this.showLayerData = { ...item }
    },
    layerQueryChild (data) {
      console.log('layerQuery', data)
      this.layerQueryData = { ...data }
    },
    // 添加全屏状态监听器
    addFullscreenListeners () {
      // 监听全屏状态变化事件
      document.addEventListener('fullscreenchange', this.handleFullscreenChange);
      document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
      document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
      document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
      // 监听窗口大小变化（F11全屏会触发此事件）
      window.addEventListener('resize', this.handleFullscreenChange);
      // 监听键盘事件，检测F11键
      document.addEventListener('keydown', this.handleKeyDown);
    },
    // 移除全屏状态监听器
    removeFullscreenListeners () {
      document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
      window.removeEventListener('resize', this.handleFullscreenChange);
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    // 处理全屏状态变化
    handleFullscreenChange () {
      // 检查JavaScript API全屏状态
      const isApiFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      console.log('全屏状态变化:', isApiFullscreen);
      console.log('document.fullscreenElement:', document.fullscreenElement);

      // 更新全屏状态
      this.isFullscreen = isApiFullscreen;

      // 全屏状态变化后重新计算缩放
      this.$nextTick(() => {
        this.calculateScale();
      });
    },

    // 处理键盘事件
    handleKeyDown (event) {
      // 检测F11键并拦截，使用与按钮相同的逻辑
      if (event.key === 'F11' || event.keyCode === 122 || event.which === 122) {
        console.log('拦截F11键，使用与按钮相同的全屏逻辑');
        // 阻止浏览器原生F11全屏
        event.preventDefault();
        event.stopPropagation();

        // 使用与按钮相同的全屏切换逻辑
        this.toggleCustomFullscreen();
        return false;
      }
    },

    // 全屏切换
    toggleCustomFullscreen () {
      if (this.isFullscreen) {
        // 退出全屏
        this.exitCustomFullscreen();
      } else {
        // 进入全屏
        this.enterCustomFullscreen();
      }
    },

    // 进入全屏
    enterCustomFullscreen () {
      console.log('进入全屏（F11或按钮触发）');

      // 使用浏览器原生全屏API
      this.tryNativeFullscreen().then(() => {
        console.log('使用原生全屏API成功');
        // isFullscreen状态会由handleFullscreenChange自动更新
      }).catch(() => {
        console.log('原生全屏API失败，使用自定义全屏');
        this.enterCustomFullscreenMode();
      });
    },

    // 尝试使用原生全屏API
    async tryNativeFullscreen () {
      return new Promise((resolve, reject) => {
        const element = document.documentElement;

        if (element.requestFullscreen) {
          element.requestFullscreen().then(() => {
            // isFullscreen状态会由handleFullscreenChange自动更新
            resolve();
          }).catch(reject);
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
          // isFullscreen状态会由handleFullscreenChange自动更新
          resolve();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
          // isFullscreen状态会由handleFullscreenChange自动更新
          resolve();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
          // isFullscreen状态会由handleFullscreenChange自动更新
          resolve();
        } else {
          reject(new Error('不支持全屏API'));
        }
      });
    },

    // 自定义全屏模式
    enterCustomFullscreenMode () {
      console.log('使用自定义全屏模式');
      this.isFullscreen = true;

      // 添加自定义全屏样式
      document.body.classList.add('custom-fullscreen');
      document.documentElement.classList.add('custom-fullscreen');

      // 添加额外的样式控制，确保完全消除白边
      document.body.style.position = 'fixed';
      document.body.style.top = '0';
      document.body.style.left = '0';
      document.body.style.width = '100vw';
      document.body.style.height = '100vh';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.background = '#000';
      document.body.style.border = 'none';
      document.body.style.outline = 'none';
      document.body.style.boxSizing = 'border-box';

      // 同时设置html元素
      document.documentElement.style.position = 'fixed';
      document.documentElement.style.top = '0';
      document.documentElement.style.left = '0';
      document.documentElement.style.width = '100vw';
      document.documentElement.style.height = '100vh';
      document.documentElement.style.margin = '0';
      document.documentElement.style.padding = '0';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.background = '#000';
      document.documentElement.style.border = 'none';
      document.documentElement.style.outline = 'none';
      document.documentElement.style.boxSizing = 'border-box';

      // 隐藏浏览器UI（如果可能）
      this.hideBrowserUI();

      // 强制重新计算布局
      setTimeout(() => {
        document.body.style.display = 'block';
        document.body.offsetHeight; // 触发重排
      }, 10);
    },

    // 退出全屏
    exitCustomFullscreen () {
      console.log('退出全屏（F11或按钮触发）');

      // 检查是否是原生全屏
      const isNativeFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      if (isNativeFullscreen) {
        // 退出原生全屏
        this.exitNativeFullscreen();
      } else {
        // 退出自定义全屏
        this.exitCustomFullscreenMode();
      }
    },

    // 退出原生全屏
    exitNativeFullscreen () {
      console.log('退出原生全屏');
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          // isFullscreen状态会由handleFullscreenChange自动更新
        }).catch(err => {
          console.log('退出原生全屏失败:', err);
        });
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
        // isFullscreen状态会由handleFullscreenChange自动更新
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
        // isFullscreen状态会由handleFullscreenChange自动更新
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
        // isFullscreen状态会由handleFullscreenChange自动更新
      }
    },

    // 退出自定义全屏模式
    exitCustomFullscreenMode () {
      console.log('退出自定义全屏模式');
      this.isFullscreen = false;

      // 移除自定义全屏样式
      document.body.classList.remove('custom-fullscreen');
      document.documentElement.classList.remove('custom-fullscreen');

      // 恢复原始样式
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.overflow = '';
      document.body.style.background = '';
      document.body.style.border = '';
      document.body.style.outline = '';
      document.body.style.boxSizing = '';
      document.body.style.display = '';

      // 恢复html元素样式
      document.documentElement.style.position = '';
      document.documentElement.style.top = '';
      document.documentElement.style.left = '';
      document.documentElement.style.width = '';
      document.documentElement.style.height = '';
      document.documentElement.style.margin = '';
      document.documentElement.style.padding = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.background = '';
      document.documentElement.style.border = '';
      document.documentElement.style.outline = '';
      document.documentElement.style.boxSizing = '';

      // 恢复浏览器UI
      this.showBrowserUI();
    },

    // 隐藏浏览器UI（尝试）
    hideBrowserUI () {
      // 尝试隐藏地址栏和工具栏
      try {
        // 对于移动端浏览器
        if (window.scrollTo) {
          window.scrollTo(0, 1);
        }

        // 尝试设置viewport
        const viewport = document.querySelector('meta[name=viewport]');
        if (viewport) {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=no');
        }

        // 尝试隐藏滚动条
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        // 尝试最大化窗口（如果可能）
        if (window.moveTo) {
          window.moveTo(0, 0);
        }
        if (window.resizeTo) {
          window.resizeTo(screen.width, screen.height);
        }
      } catch (e) {
        console.log('隐藏浏览器UI失败:', e);
      }
    },

    // 显示浏览器UI
    showBrowserUI () {
      try {
        // 恢复viewport
        const viewport = document.querySelector('meta[name=viewport]');
        if (viewport) {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        }

        // 恢复滚动条
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      } catch (e) {
        console.log('恢复浏览器UI失败:', e);
      }
    },

    // ========== 缩放相关方法 ==========

    // 计算缩放比例
    calculateScale () {
      const container = this.$el;
      if (!container) return;

      let containerWidth, containerHeight;

      if (this.isFullscreen) {
        // 全屏模式下使用视口尺寸
        containerWidth = window.innerWidth;
        containerHeight = window.innerHeight;
      } else {
        // 普通模式下使用容器尺寸
        containerWidth = container.clientWidth;
        containerHeight = container.clientHeight;
      }

      // 计算宽度和高度的缩放比例，取较小值确保内容完全显示
      const scaleX = containerWidth / this.baseWidth;
      const scaleY = containerHeight / this.baseHeight;

      // 使用较小的缩放比例，保持宽高比
      this.scaleValue = Math.min(scaleX, scaleY);

      // 限制缩放范围，避免过小或过大
      this.scaleValue = Math.max(0.3, Math.min(2, this.scaleValue));

      console.log('缩放计算:', {
        mode: this.isFullscreen ? '全屏' : '普通',
        containerSize: { width: containerWidth, height: containerHeight },
        baseSize: { width: this.baseWidth, height: this.baseHeight },
        scaleValue: this.scaleValue
      });
    },

    // 添加窗口大小变化监听器
    addResizeListeners () {
      window.addEventListener('resize', this.handleResize);
    },

    // 移除窗口大小变化监听器
    removeResizeListeners () {
      window.removeEventListener('resize', this.handleResize);
    },

    // 处理窗口大小变化
    handleResize () {
      // 使用防抖，避免频繁计算
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        this.calculateScale();
      }, 100);
    },

    // 手动设置缩放比例（可选功能）
    setScale (scale) {
      if (scale > 0 && scale <= 3) {
        this.scaleValue = scale;
      }
    },

    // 重置缩放比例
    resetScale () {
      this.calculateScale();
    }
  }
};
</script>

<style lang="less" scoped>
.subject {
  width: 100%;
  height: 112%;
  position: relative;
  overflow: hidden;
  background: #000;
}

/* 缩放容器样式 */
.scale-container {
  width: 1920px;
  height: 1080px;
  position: relative;
  transition: transform 0.3s ease-in-out;
  /* 水平居中定位 */
  left: 50%;
}

/* 全屏模式下的样式 */
.subject.fullscreen-mode {
  height: 100vh;
  width: 100vw;
}

.subject.fullscreen-mode .scale-container {
  /* 全屏时居中显示 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center center;
  margin: 0;
}

/* 自定义全屏样式 */
:global(.custom-fullscreen) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 999999 !important;
  background: #000 !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  outline: none !important;
}

:global(.custom-fullscreen body) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: #000 !important;
  border: none !important;
  outline: none !important;
  box-sizing: border-box !important;
}

:global(.custom-fullscreen html) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: #000 !important;
  border: none !important;
  outline: none !important;
  box-sizing: border-box !important;
}

/* 确保全屏时所有元素都在视口内 */
:global(.custom-fullscreen #app) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: #000 !important;
  border: none !important;
  outline: none !important;
  box-sizing: border-box !important;
}

/* 确保所有子元素也没有边距 */
:global(.custom-fullscreen *) {
  box-sizing: border-box !important;
}

/* 特别处理可能产生白边的元素 */
:global(.custom-fullscreen .ant-layout),
:global(.custom-fullscreen .ant-layout-content),
:global(.custom-fullscreen .ant-layout-sider),
:global(.custom-fullscreen .ant-layout-header),
:global(.custom-fullscreen .ant-layout-footer) {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: #000 !important;
}

/* 地图作为底层 */
.map-modules {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.map-operation-modules {
  position: absolute;
  height: 150px;
  width: 650px;
  // top: 606px;
  bottom: calc(29% + 5px);
  right: 440px;
  z-index: 100;

  display: flex;
  /* 关键：让子元素水平排列 */
  align-items: center;
  /* 垂直居中 */
  gap: 20px;
  /* 两个组件之间的间距 */
}

/* 顶部导航栏样式 */
.top-modules {
  background-color: rgba(3, 16, 42, 0.8);
  /* 半透明效果 */
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  // padding: 0 20px;
}

/* 左侧模块样式 */
.left-modules {
  height: 75vh;
  /* 半透明浅蓝色 */
  position: absolute;
  left: 23px;
  top: calc(6% - 4px);
  /* 留出底部空间 */
  z-index: 100;
  padding-top: 30px;
  padding-bottom: 0px;
  gap: 26px;
  /* 关键修改：禁用滚动条 */
}

.left-modules-bg {
  background: url(~@/assets/bigusers/largeScreen/leftBox.png) repeat;
  background-size: 100% auto;
  height: 100vh;
  width: 25%;
  position: absolute;
  left: 0;
  top: calc(6% - 4px);
  z-index: 100;
}

/* 右侧模块样式 */
.right-modules {
  height: 75vh;
  position: absolute;
  right: 23px;
  top: calc(6% - 4px);
  z-index: 100;
  // padding: 15px;
  padding-top: 30px;

  padding-bottom: 0px;
  gap: 26px;
  /* 设置子元素之间的间距，替代margin-top */
}

.right-modules-bg {
  background: url(~@/assets/bigusers/largeScreen/rightBox.png) repeat;
  background-size: 100% auto;
  height: 100vh;
  width: 25%;
  position: absolute;
  right: 0;
  top: calc(6% - 4px);
  z-index: 100;
}

.bottom-modules {
  position: absolute;
  bottom: 7%;
  left: 23px;
  right: 23px;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 13px;

}

.bottom-modules-bg {
  background: url(~@/assets/bigusers/largeScreen/bottomBoxBg.png) repeat-x;
  background-size: auto 100%;
  height: 30vh;
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 99;
}

.left-modules,
.left-modules-bg,
.bottom-modules,
.bottom-modules-bg,
.right-modules-bg,
.right-modules,
.map-operation-modules {
  pointer-events: none;

  >* {
    pointer-events: auto;
  }
}
</style>